import { Drawer } from '@reveni-io/reveni-ui'

import CreateViewForm from './CreateViewForm/CreateViewForm'

const CreateViewDrawer = ({
  show,
  onClose,
  onSave,
  saving,
  initialName,
  groups,
  fixedGroupIds,
  canSelectGroups,
  loadingGroups,
}) => {
  return (
    <Drawer show={show} onClose={onClose} options={{ showHeaderActions: false }}>
      <CreateViewForm
        initialName={initialName}
        groups={groups}
        fixedGroupIds={fixedGroupIds}
        canSelectGroups={canSelectGroups}
        loadingGroups={loadingGroups}
        saving={saving}
        onCancel={onClose}
        onSave={onSave}
      />
    </Drawer>
  )
}

export default CreateViewDrawer
